import { render, staticRenderFns } from "./RegisterApply.vue?vue&type=template&id=4920f755&scoped=true&"
import script from "./RegisterApply.vue?vue&type=script&lang=js&"
export * from "./RegisterApply.vue?vue&type=script&lang=js&"
import style0 from "./RegisterApply.vue?vue&type=style&index=0&id=4920f755&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4920f755",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/nantong-hrpark-prod-mobile-property(微信公众号-物业）/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4920f755', component.options)
    } else {
      api.reload('4920f755', component.options)
    }
    module.hot.accept("./RegisterApply.vue?vue&type=template&id=4920f755&scoped=true&", function () {
      api.rerender('4920f755', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/RegisterApply.vue"
export default component.exports